// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2kl8y","buttons":"RemoveExpirationActionButtons_buttons__1XhEa"};